import './CompletedInterview_Page.css';
import Icons_Repository from '../Icons/Icons_Repository';

function sanitizeForAttribute(value: string) {
  return value
    ?.replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function sanitizeForText(value: string) {
  return value
    ?.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}



function CompletedInterview_Page({recruiterEmail, recruiterName}:any){
    const safeEmail = sanitizeForAttribute(recruiterEmail || '');
    const safeName = sanitizeForText(recruiterName || '');
    return (
        <div className='Completed-page-container'>

        
            <div className="Completed-page">
                <div className="Completed-card">
                    <div className="Completed-header">
                        <div className='calendar-icon'>
                            <Icons_Repository iconName='calendar' />
                        </div>
                        <h2 className="Completed-title">Interview Completed</h2>
                    </div>
                    <div className='Completed-body'>
                        <div className='Completed-body-text'>
                            Your interview has been completed successfully. If you have any concerns or need additional details, please reach out to your recruiter,{' '}
                            <a
                                href={`mailto:${safeEmail}`}
                                className="support-email-link"
                            >
                                {safeName}
                            </a>
                        </div>
                    </div>
                    

                </div>
            </div>
        </div>
    )
}
export default CompletedInterview_Page